import { fetchApi } from "../utils/apiUtils";

// Create the body with the from_date and to_date
const daterange = {
  from_date: "2022-10-10",
  to_date: "2022-10-10",
};

// const apiCall = async (endpoint, options = {}) => {

//     const apiUrl = `${BASE_URL}${endpoint}`;

//     const response = await fetch(apiUrl, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             ...options.headers, 
//         },
//         body: JSON.stringify(daterange),
//     });

//     if (!response.ok) {
//         throw new Error('Failed to fetch dashboard tiles');
//     }

//     return await response.json();

//   };

// Common API functions
export const getDashboardTiles = async (accessToken) => {
  const headers = {
    Authorization: `Bearer ${accessToken}`, // Include Bearer token in the headers
  };
  // return await apiCall('dashboard-tiles/', { headers }); // API call to get dashboard tiles
  return await fetchApi('dashboard-tiles/', { method: 'POST', headers: headers, body: daterange, requiresAuth: true })
};

// api to get top tile data in dashboard page, which gives data of current customer logged in
export const fetchCustomerCounts = async (startDate, endDate, viewMode, customerId) => {
  const response = await fetchApi('dashboard-partner-customer-list/',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: {
        from_date: startDate,
        to_date: endDate,
        ...(viewMode === "customer-view" && { customer: customerId })
      },
      requiresAuth: true
    }
  )
  return await response;
};

export const getDashboardDataList = async (accessToken, page, searchTerm, startDate, endDate, order_field, order_type, selectedFilterTags) => {
  const headers = {
    Authorization: `Bearer ${accessToken}`, // Include Bearer token in the headers
  };
  const query = searchTerm || "";
  const payload = {
    "from_date": startDate,
    "to_date": endDate,
    "name": `${query}`,
    "order_type": order_type,
    "order_field": order_field,
    "tag_ids": selectedFilterTags
  }

  //return await apiCall('dashboard/', { headers }); // API call to get dashboard tiles
  // return await fetchApi(`dashboard/?page=${page}`,{method: 'POST',headers:headers,body:payload,requiresAuth:true})
  return await fetchApi(`workflows_filter/?page=${page}`, { method: 'POST', headers: headers, body: payload, requiresAuth: true })
};